// Google Analytics 4 event tracking utility
const GA_ID = "G-71240G35GW";

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

// Track page views (SPA navigation)
export function trackPageView(path, title) {
  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: path,
      page_title: title,
      page_location: window.location.origin + path,
    });
  }
}

// Track custom events
export function trackEvent(eventName, params = {}) {
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
}

// ─── Pre-defined conversion events ───

export function trackSignUp(method = "email") {
  trackEvent("sign_up", { method });
}

export function trackLogin(method = "email") {
  trackEvent("login", { method });
}

export function trackAuditStarted(companyName, industry) {
  trackEvent("audit_started", {
    company_name: companyName,
    industry: industry,
  });
}

export function trackAuditCompleted(score, tier) {
  trackEvent("audit_completed", {
    score: score,
    tier: tier,
    value: score,
  });
}

export function trackPaymentCompleted(auditId) {
  trackEvent("purchase", {
    transaction_id: auditId,
    currency: "USD",
    value: 4495,
    items: [{ item_name: "Growth Blueprint", price: 4495 }],
  });
}

export function trackReportGenerated(score) {
  trackEvent("report_generated", { score });
}

export function trackReportDownloaded(type) {
  trackEvent("file_download", {
    file_name: type === "deck" ? "Executive Deck" : "Growth Report",
    file_extension: "pdf",
    content_type: type,
  });
}

export function trackCallBooked(date, source) {
  trackEvent("generate_lead", {
    currency: "USD",
    value: 100,
    event_label: "strategy_call_booked",
    booking_date: date,
    source: source,
  });
}

export function trackChatOpened() {
  trackEvent("chat_opened", { location: "landing_page" });
}

export function trackChatLeadCaptured(email) {
  trackEvent("generate_lead", {
    currency: "USD",
    value: 50,
    event_label: "chatbot_lead_captured",
    method: "chatbot",
  });
}

export function trackCTAClicked(ctaName, location) {
  trackEvent("cta_click", {
    cta_name: ctaName,
    location: location,
  });
}
